import React from "react";
import "./App.css";
import logo from "./logo.png";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <br />
        <h1 style={{ fontStyle: "italic" }}>Inhale and exhale code!</h1>
      </header>
    </div>
  );
}

export default App;
